export default __webpack_public_path__ + "static/post4-c467c8361949c3cfd11d666225a90a79.jpg";